import React, {useEffect, useState} from "react";
import {injectIntl} from "react-intl";
import Modal from "@amzn/meridian/modal";
import Column from "@amzn/meridian/column";
import Text from "@amzn/meridian/text";
import Icon from "@amzn/meridian/icon";
import infoTokens from "@amzn/meridian-tokens/base/icon/alert-informational-small";
import {getLocalizedMessage} from "../../util/Localization";
import orientationImage from "./assets/vapr-orientation.webp";

export const ORIENTATION_MODAL_WIDTH = 1248;
const ORIENTATION_IMAGE_WIDTH = 1519;
const ORIENTATION_IMAGE_HEIGHT = 989;

// Plain button so the 16px icon gets no extra padding.
const ICON_BUTTON_STYLE = {
    display: "inline-flex",
    alignItems: "center",
    padding: 0,
    margin: 0,
    border: 0,
    background: "none",
    lineHeight: 0,
    cursor: "pointer"
};

// Keeps clicks from bubbling to a surrounding sortable header (React bubbles through portals too).
const stopPropagation = (event) => event.stopPropagation();

/** Info icon button that shows the orientation guide. */
export const VaprOrientationInfoButton = injectIntl(({intl, onClick, expanded}) => (
    <button
        type="button"
        aria-label={getLocalizedMessage({intl, stringId: "vaprorientation.help.label"})}
        title={getLocalizedMessage({intl, stringId: "vaprorientation.help.label"})}
        aria-expanded={expanded}
        onClick={(event) => {
            stopPropagation(event);
            onClick();
        }}
        style={ICON_BUTTON_STYLE}
    >
        <Icon tokens={infoTokens}/>
    </button>
));

/** Orientation text and diagram; the diagram scales to the width of its container. */
export const VaprOrientationGuideContent = injectIntl(({intl}) => (
    <Column spacing="300">
        <Text type="b300">{getLocalizedMessage({intl, stringId: "tooltip.vaprorientation"})}</Text>
        <img
            src={orientationImage}
            alt={getLocalizedMessage({intl, stringId: "vaprorientation.image.alt"})}
            width={ORIENTATION_IMAGE_WIDTH}
            height={ORIENTATION_IMAGE_HEIGHT}
            style={{display: "block", width: "100%", height: "auto"}}
        />
    </Column>
));

// Info icon that opens the orientation guide in a centred modal (Tooltip only takes a string).
const VaprOrientationGuide = ({intl}) => {
    const [open, setOpen] = useState(false);

    // Every open Meridian Modal closes on Escape via a window listener, so inside another modal
    // (Add/Update) Escape would close both. Catch it first and close only the guide.
    useEffect(() => {
        if (!open) {
            return undefined;
        }
        const onKeyDown = (event) => {
            if (event.key === "Escape" || event.key === "Esc" || event.keyCode === 27) {
                event.stopPropagation();
                setOpen(false);
            }
        };
        window.addEventListener("keydown", onKeyDown, true);
        return () => window.removeEventListener("keydown", onKeyDown, true);
    }, [open]);

    return (
        <React.Fragment>
            <VaprOrientationInfoButton onClick={() => setOpen(true)} expanded={open}/>
            <span onClick={stopPropagation}>
                <Modal
                    title={getLocalizedMessage({intl, stringId: "location.orientation"})}
                    open={open}
                    onClose={() => setOpen(false)}
                    closeLabel="Close"
                    width={ORIENTATION_MODAL_WIDTH}
                    scrollContainer="viewport"
                >
                    <VaprOrientationGuideContent/>
                </Modal>
            </span>
        </React.Fragment>
    );
};

export default injectIntl(VaprOrientationGuide);



// WEBPACK FOOTER //
// ./src/components/devicemanagement/vaprdevice/VaprOrientationGuide.js